module.exports = __webpack_public_path__ + "static/media/Shape-Goldman-Sachs-Logo.cc96395e.png";